/* eslint-disable no-console */
import React from 'react';
import { Transaction as TransactionType } from '../types';
import { transactionItem } from '../../styling/style-classes';
import AdImage from '../../components/AdImage';
import NotificationDot from '../../components/NotificationDot';
import { createTransactionLink } from './utils';
import pulseClient from '../../pulse-tracking';

type Props = {
    transaction: TransactionType;
};

const Transaction = ({ transaction }: Props) => {
    const { adId, transactionId, statusString, title, image } = transaction;

    const trackTransactionClick = () =>
        pulseClient.trackAdClick(adId, statusString);

    return (
        <article
            key={adId || transactionId}
            className={`tjt-transaction-item ${transactionItem.box}`}
        >
            <div className="pl-12 flex-grow flex flex-col-reverse truncate">
                <h3 className={transactionItem.adName}>{title}</h3>
                <a
                    href={createTransactionLink(transaction)}
                    className={`tjt-click-area ${transactionItem.actionLink}`}
                    onClick={trackTransactionClick}
                >
                    {statusString}
                </a>
            </div>

            <div className="relative flex-shrink-0">
                <NotificationDot />
                <AdImage img={image} className={transactionItem.adImg} />
            </div>
        </article>
    );
};

export default Transaction;
